"use client";
import { AntdRegistry } from "@ant-design/nextjs-registry";
import { ConfigProvider as AntdConfigProvider } from "antd";
import { ConfigProvider as AntdMobileConfigProvider } from "antd-mobile";
import mobileEnUS from "antd-mobile/es/locales/en-US";
import mobileZhHK from "antd-mobile/es/locales/zh-HK";
import antdEnUS from "antd/locale/en_US";
import antdZhHK from "antd/locale/zh_HK";
import type { PropsWithChildren } from "react";
import { Toaster } from "react-hot-toast";
import { AuthSessionProvider } from "@repo/web/lib/auth";

type Props = PropsWithChildren<{
	locale: string;
}>;

export function Providers({ children, locale }: Props) {
	return (
		<AntdRegistry>
			<AntdConfigProvider
				locale={locale === "zh-HK" ? antdZhHK : antdEnUS}
				theme={{
					token: {
						colorPrimary: "#003248",
						colorInfo: "#597A88",
						colorSuccess: "#52c41a",
						colorWarning: "#faad14",
						colorError: "#ff4d4f",
						colorTextBase: "#1f2937",
						colorBgBase: "#ffffff",
						borderRadius: 4,
						wireframe: false,
					},
					components: {
						Layout: {
							headerBg: "#ffffff",
						},
						Menu: {
							itemSelectedBg: "rgba(0, 50, 72, 0.1)",
							itemSelectedColor: "#003248",
							horizontalItemSelectedColor: "#003248",
							horizontalItemHoverColor: "#003248",
							itemHoverColor: "#003248",
						},
						Button: {
							primaryColor: "#ffffff",
							defaultBg: "#ffffff",
						},
						Avatar: {
							colorBgContainer: "#003248",
							colorTextLightSolid: "#ffffff",
						},
					},
				}}
			>
				<AntdMobileConfigProvider
					locale={locale === "zh-HK" ? mobileZhHK : mobileEnUS}
				>
					<Toaster position="top-center" />
					{children}
				</AntdMobileConfigProvider>
			</AntdConfigProvider>
		</AntdRegistry>
	);
}
